import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEventTracker } from "./useEventTracker";
export var useOnRouteChange = function useOnRouteChange(group) {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var location = useLocation();
  useEffect(function () {
    trackEvent({
      event: 'Viewed page',
      group: group
    });
  }, [location === null || location === void 0 ? void 0 : location.pathname, group]);
};